const initialState = {
    teamMemberList: [],
    isFetchingTeamMember: false,
    isAddingTeamMember: false,
};

const TeamMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_ADD_TEAM_MEMBER":
            return { ...state, isAddingTeamMember: true };
        case "SUCCESS_ADD_TEAM_MEMBER":
            return { ...state, teamMemberList: action.payload, isAddingTeamMember: false };
        case "ERROR_ADD_TEAM_MEMBER":
            return { ...state };


        case "REQUEST_GET_TEAM_MEMBER":
            return { ...state, isFetchingTeamMember: true };
        case "SUCCESS_GET_TEAM_MEMBER":
            return { ...state, teamMemberList: action.payload.data, isFetchingTeamMember: false };
        case "ERROR_GET_TEAM_MEMBER":
            return { ...state, isFetchingTeamMember: false };

        default:
            return state;
    }
};
export default TeamMemberReducer;